import { useDeleteEntityAttribute } from "@/modules/dynamic-attributes/feature/remove-dynamic-attribute";
import { More } from "@/shared/actions/more";

export type RemoveAttributeProps = {
  attributeId: string;
};

export function RemoveAttribute({ attributeId }: RemoveAttributeProps) {
  const remove = useDeleteEntityAttribute();

  return <More.Delete onClick={() => remove(attributeId)} />;
}
